export default __webpack_public_path__ + "static/char-s-34-zh-Hans-e6a6db3eec540e609e6675661c0d4ac1.webp";